import React, { useEffect, useMemo, useState } from "react";

import { Chip, Paper, Popper, Stack, Typography } from "@mui/material";
import { AsyncContentMui } from "components/Async-content/AsyncContentMui";
import { uniqueId } from "lodash";
import { ISearchItem } from "store/types";

import { ISearchResults } from "./Advanced-search";
import { ListItem } from "./ListItem";

interface IProps {
  open: boolean;
  anchorEl: HTMLDivElement | null;
  loading: boolean;
  state: ISearchResults;
  searchValue: string;
  onClose: () => void;
  resetSearchState: () => void;
  inputWidth: number;
}

export const SearchPopover: React.FC<IProps> = ({
  open,
  anchorEl,
  loading,
  state,
  searchValue,
  resetSearchState,
  inputWidth
}) => {
  const [selectedTab, setSelectedTab] = useState<keyof ISearchResults>("all");
  // const [searchWithinFiles, setSearchWithinFiles] = useState<boolean>(false);

  const tabs = useMemo(
    () => [
      { label: `All (${state.all.length})`, key: "all" },
      { label: `Deals (${state.deals.length})`, key: "deals" },
      { label: `Files (${state.files.length})`, key: "files" },
      { label: `Workspace (${state.workspace.length})`, key: "workspace" },
      { label: `Characteristics (${state.characteristics.length})`, key: "characteristics" }
    ],
    [state]
  );

  const isTabEmpty = (tab: keyof ISearchResults) => {
    return !state[tab].length;
  };

  useEffect(() => {
    if (!searchValue) {
      setSelectedTab("all" as keyof ISearchResults);
    }
  }, [searchValue]);

  useEffect(() => {
    if (isTabEmpty(selectedTab)) {
      setSelectedTab("all" as keyof ISearchResults);
    }
  }, [state]);

  return (
    <Popper sx={{ zIndex: 50 }} open={open} anchorEl={anchorEl} placement="bottom-start">
      <Paper sx={{ width: inputWidth, maxHeight: 500, borderRadius: "8px" }}>
        <AsyncContentMui isLoading={loading}>
          <Stack flexDirection="column" gap="10px" sx={{ height: "100%" }}>
            {/* <Stack sx={{ padding: "10px" }} direction="row" gap="10px" alignItems="center" justifyContent="flex-end">
              <Typography fontSize="15px">Search within files</Typography>
              <Checkbox
                checked={searchWithinFiles}
                onChange={(e) => {
                  setSearchWithinFiles(e.target.checked);
                  setSelectedTab("all" as keyof ISearchResults);
                }}
              />
            </Stack> */}

            {!!state.all.length && (
              <Stack sx={{ padding: "10px", overflow: "auto" }} direction="row" gap="6px">
                {tabs.map((tab) => (
                  <Chip
                    key={tab.key}
                    label={tab.label}
                    disabled={isTabEmpty(tab.key as keyof ISearchResults)}
                    onClick={() => setSelectedTab(tab.key as keyof ISearchResults)}
                    sx={{
                      fontSize: "12px",
                      backgroundColor: selectedTab === tab.key ? "#C3C9CF" : "#F5F6F7",
                      height: "24px",
                      "& .MuiChip-label": {
                        padding: "0 8px"
                      }
                    }}
                  />
                ))}
              </Stack>
            )}
            <Stack sx={{ overflow: "auto", maxHeight: "310px" }}>
              {state.all.length ? (
                state[selectedTab].map((item: ISearchItem) => (
                  <ListItem key={uniqueId()} item={item} resetSearchState={resetSearchState} />
                ))
              ) : (
                <Typography sx={{ fontSize: "12px", color: "#92A7BC", padding: "10px" }}>Nothing found</Typography>
              )}
            </Stack>
          </Stack>
        </AsyncContentMui>
      </Paper>
    </Popper>
  );
};
